import { useContext, useEffect, useState } from "react";
import { CardPVVideo } from "../components/cardpvvideo";
import { getParameter } from "../utils/consumir";
import { getFlagByCountryId, ProcesarDuracion } from "../utils/utilidades";
import "./evento.css";
import {
  faCircleXmark,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import { language, Textos } from "../texto";
import ConfigContext from "../utils/Config";
import AuthContext from "../utils/Auth";
import { useTranslation } from "react-i18next";
import {
  deleteEventById,
  deleteVideoById,
  getEventById,
} from "../utils/Api/eventsApi";
import moment from "moment";
import useGrantAccess from "../hooks/useAccess";
import { ClubDataProps, VideoProps } from "../types/videoTypes";
import { InfiniteScrollComponent } from "../components/InfiniteScrollComponent";
import EventComponent from "../components/Events/EventComponent";
import { formatIfISO } from "../utils/helpers";

type evento = {
  id: number;
  eventname: string;
  eventdate: string;
  id_club: number;
  club?: ClubDataProps;
  eventenddate: string;
  eventendtime: string;
  eventinitdate: string;
  eventinitime: string;
  urlimage: string;
  strams?: {
    count: number;
  };
  lives?: VideoProps[];
};

export function Evento() {
  const idevento = getParameter("id") || "";
  const [t] = useTranslation("global");
  const [eventsParams, setEventsParams] = useState<evento>();
  const { currentConfig, GetConfig } = useContext(ConfigContext);

  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [editarEvento, seteditarEvento] = useState(false);
  const [ClubList, setClubList] = useState<any[]>([]);
  const { currentUser } = useContext(AuthContext);
  const { isAdminClubSuperPro, isAdmin } = useGrantAccess(currentUser);
  const [visibleCount, setVisibleCount] = useState<number>(21);
  useEffect(() => {
    if (idevento !== undefined) {
      GetConfig();
      getDataEvents();
      cargarClubs();
    }
  }, [idevento]);

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 21);
    setPage((prev) => prev + 1);
  };

  const getDataEvents = async () => {
    setLoading(true);
    try {
      const event_id = Number(idevento);
      const resp = await getEventById(event_id);
      const event: evento = resp.data;
      //console.log("que trae event?", event);
      const defaultDate = moment(event.eventdate).utc().format();
      //@ts-ignore
      const urlimagen = event?.urlimagen;
      setEventsParams({
        ...event,
        eventenddate: event.eventenddate
          ? moment(event.eventenddate).utc().format()
          : defaultDate,
        eventendtime: event.eventendtime
          ? moment(event.eventendtime).utc().format()
          : defaultDate,
        eventinitime: event.eventendtime
          ? moment(event.eventinitime).utc().format()
          : defaultDate,
        eventinitdate: event.eventinitdate
          ? moment(event.eventinitdate).utc().format()
          : defaultDate,
        eventdate: event.eventdate
          ? moment(event.eventdate).utc().format()
          : defaultDate,
        urlimage: urlimagen,
      });
    } catch (error) {
      console.error(
        "Hubo un error al traer el evento especifico",
        error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const deleteEvent = (id: number) => {
    deleteEventById(id)
      .then((resp: any) => {
        Swal.fire({
          icon: "success",
          title: `${t("Events.Modals.deleteDescription")}`,
        });
        window.location.href = "/eventos";
      })
      .catch((err: any) => {
        console.error("No se pudo borrar el evento", err);
        Swal.fire({
          icon: "error",
          title: `${t("Events.Modals.eventDeleteError")}`,
        });
      });
  };

  function cargarClubs() {
    let clubes: any[] = [];

    currentConfig?.clubs.map((x: any) => {
      if (x.id_admin === currentUser?.id_player) {
        clubes.push({
          label: x.displayname,
          value: x.id,
        });
      }
    });
    setClubList(clubes);
  }

  const deleteVideo = (id: string) => {
    Swal.fire({
      title: Textos[language].eventdeletevideoq,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#060707",
      cancelButtonColor: "#f44336",
      confirmButtonText: `${t("Events.Buttons.deleteVideo")}`,
      cancelButtonText: `${t("Events.Buttons.cancel")}`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteVideoById(id)
          .then((resp: any) => {
            Swal.fire({
              icon: "success",
              title: `${t("Events.Modals.eventDeleteVideoOk")}`,
            });
            window.location.reload();
          })
          .catch((err: any) => {
            console.error("Hubo un problema al borrar el video", err);
            Swal.fire({
              icon: "error",
              title: `${t("Events.Modals.eventDeleteVideoError")}`,
            });
          });
        // Get(`${URL_API}/event/quit/${id}`).then(
        //   (res) => {
        //     Swal.fire({
        //       icon: "success",
        //       title: Textos[language].eventdeletevideook,
        //     });
        //     window.location.reload();
        //   },
        //   (err) => {
        //     Swal.fire({
        //       icon: "error",
        //       title: Textos[language].eventdeletevideoerror,
        //     });
        //     //console.log(err);
        //   }
        // );
      }
    });
  };

  function formatDataUpd() {
    const values = {
      id: eventsParams.id,
      eventname: eventsParams.eventname,
      eventdate: formatIfISO(eventsParams.eventdate, "YYYY-MM-DDTHH:mm"),
      id_club: eventsParams.id_club,
      eventinitdate: formatIfISO(
        eventsParams.eventinitdate,
        "YYYY-MM-DDTHH:mm"
      ),
      eventenddate: formatIfISO(eventsParams.eventenddate, "YYYY-MM-DDTHH:mm"),
      urlimage: eventsParams.urlimage,
    };
    return values;
  }
  function AdminClub() {
    currentConfig?.clubs.map((x: any): boolean => {
      return (
        x.id === eventsParams?.id_club && x.id_admin === currentUser?.id_player
      );
    });
  }
  const isAdminSSPWithClub = isAdminClubSuperPro() && AdminClub();
  const hasAdminClub = isAdmin() && AdminClub();

  const hasAccess = isAdmin() || hasAdminClub || isAdminSSPWithClub;

  function getVideoStatus(video: VideoProps): "highlight" | "live" | "stream" {
    if (video.ishighlight) return "highlight";
    if (video.islive) return "live";
    return "stream";
  }

  return loading ? (
    <div className="cssload-loader">
      <div className="cssload-inner cssload-one"></div>
      <div className="cssload-inner cssload-two"></div>
      <div className="cssload-inner cssload-three"></div>
    </div>
  ) : (
    <div className="flex flex-col w-full">
      {eventsParams?.urlimage !== null ? (
        <div
          className="bannerImage"
          style={{
            backgroundImage: `url('${eventsParams?.urlimage}')`,
          }}
        >
          <div className="titleEvent">{eventsParams?.eventname}</div>
        </div>
      ) : (
        <div className="bannerTitle">
          <div className="titleEvent">{eventsParams?.eventname}</div>
        </div>
      )}
      {hasAccess && (
        <div className="flex items-center justify-end gap-4 py-3 mr-3">
          <div
            className="flex items-center p-4 text-base font-medium text-center text-white bg-black rounded-md hover:ring-2 hover:ring-black hover:text-black hover:bg-white hover:cursor-pointer"
            onClick={() => {
              seteditarEvento(true);
            }}
          >
            <FontAwesomeIcon className="eventicon" icon={faEdit} />
            {t("Events.editEvent")}
          </div>

          <div
            className="flex items-center p-4 text-base font-medium text-center text-white bg-red-500 rounded-md hover:ring-2 hover:ring-black hover:text-black hover:bg-red-300 hover:cursor-pointer"
            onClick={() => {
              if (currentUser !== null) {
                if (hasAccess) {
                  Swal.fire({
                    icon: "warning",
                    title: `${t("Events.Modals.titleDelete")}`,
                    text: `${t("Events.Modals.descriptionDelete")}`,
                    confirmButtonColor: "#060707",
                    cancelButtonColor: "#f44336",
                    showCancelButton: true,
                    confirmButtonText: `${t("Events.Buttons.delete")}`,
                    cancelButtonText: `${t("Events.Buttons.cancel")}`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      deleteEvent(eventsParams.id);
                    }
                  });
                } else {
                  Swal.fire({
                    icon: "error",
                    title: `${t("Events.Modals.doesnothavepermission")}`,
                  });
                }
              }
            }}
          >
            <FontAwesomeIcon className="eventicon" icon={faTrash} />
            {t("Events.Buttons.delete2")}
          </div>
        </div>
      )}
      <div className="flex flex-row flex-wrap justify-between w-full">
        {eventsParams?.lives
          ?.slice()
          .sort((a, b) => {
            if (a.islive && !b.islive) return -1;
            if (!a.islive && b.islive) return 1;

            return (
              new Date(b.initialtime).getTime() -
              new Date(a.initialtime).getTime()
            );
          })
          .slice(0, visibleCount)
          .map((vid: VideoProps) => {
            return (
              <div key={vid.id} className="relative m-2 w-fit">
                {hasAccess && (
                  <button
                    onClick={() => {
                      console.log("Que llega de vid.id", vid.id);
                      deleteVideo(vid.id);
                    }}
                    className="absolute z-10 mb-4 text-red-600 top-1 right-1 hover:text-red-800"
                  >
                    <FontAwesomeIcon
                      icon={faCircleXmark}
                      size="2x"
                      className="mr-2 shadow-sm"
                    />
                  </button>
                )}

                <CardPVVideo
                  status={getVideoStatus(vid)}
                  viewsCount={vid?.views}
                  LikesCount={vid?.like}
                  dislikesCount={vid?.dislike}
                  cameraName={vid?.cameraname}
                  duration={ProcesarDuracion(
                    new Date(vid?.initialtime),
                    vid?.endtime ? new Date(vid?.endtime) : new Date()
                  )}
                  title={vid?.description}
                  club={`${eventsParams?.club.clubname} 
               ${
                 eventsParams?.club?.countryicon ??
                 getFlagByCountryId(eventsParams?.club?.id_country) ??
                 ""
               } `}
                  user={vid?.userdata?.firstname}
                  imageuser={
                    vid?.userdata?.photoicon
                      ? vid?.userdata?.photoicon
                      : "https://storage.googleapis.com/publicsportprotv/892781.png"
                  }
                  previewimage={
                    vid?.photopath === null
                      ? "https://diretube.com/go/wp-content/plugins/video-thumbnails/default.jpg"
                      : vid?.photopath
                  }
                  id={vid?.id}
                  alldata={vid}
                  date={vid?.initialtime}
                  highlightcat={Number(vid?.id_highlightcat) || 0}
                />
              </div>
            );
          })}
        <InfiniteScrollComponent
          loading={loading}
          hasMore={visibleCount < eventsParams?.lives?.length}
          onLoadMore={handleShowMore}
        />
      </div>
      <div className="flex items-center justify-center my-4">
        {visibleCount >= eventsParams?.lives?.length && (
          <h4 className="text-xl font-semibold text-center text-gray-800">
            Wow, llegaste al final.Eso es todo lo que tenemos hasta el momento.
          </h4>
        )}
      </div>
      {editarEvento && (
        <EventComponent
          isOpen={editarEvento}
          SetOpen={seteditarEvento}
          title={t("Events.editEvent")}
          ClubList={ClubList}
          DataEvent={formatDataUpd()}
        />
      )}
    </div>
  );
}
